export function saveLocalStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function getLocalStorage(key) {
    const Item = localStorage.getItem(key);
    return JSON.parse(Item);
}

export function clearLocalStorage() {
    localStorage.clear();
}

// Save page state (filters, search, pagination)
// Saves state directly to cacheKey with screenName included in the object
export function savePageState(screenName, state, cacheKey = 'screenCache') {
    try {
        // Include screenName inside the state object
        const stateWithScreenName = {
            screenName: screenName,
            ...state
        };
        
        // Save directly to the cacheKey
        localStorage.setItem(cacheKey, JSON.stringify(stateWithScreenName));
    } catch (error) {
        console.error('Error saving page state:', error);
    }
}

// Get page state
// Retrieves state directly from cacheKey
export function getPageState(screenName, cacheKey = 'screenCache') {
    try {
        const cached = localStorage.getItem(cacheKey);
        if (!cached) return null;
        
        const data = JSON.parse(cached);
        
        // Check if the cached data belongs to the requested screen
        if (data.screenName === screenName) {
            return data;
        }
        
        return null;
    } catch (error) {
        console.error('Error getting page state:', error);
        return null;
    }
}

// Clear specific page state
// Removes the cacheKey if it belongs to the specified screen
export function clearPageState(screenName, cacheKey = 'screenCache') {
    try {
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
            const data = JSON.parse(cached);
            
            // Only remove if it belongs to the specified screen
            if (data.screenName === screenName) {
                localStorage.removeItem(cacheKey);
            }
        }
    } catch (error) {
        console.error('Error clearing page state:', error);
    }
}